<template>
  <div class="container">
    <div class="handle-box">
      <el-cascader :props="props" v-model="area_store" placeholder="选择或搜索门店" collapse-tags clearable
        filterable></el-cascader>
      <el-input v-model="query.product_name" placeholder="商品名称" class="handle-input mr10" :controls="false"></el-input>

      <el-input v-model="query.mac_id" placeholder="设备编码" :controls="false" clearable style="width: 200px;"></el-input>

      <el-input-number v-model="query.moto_num" :min="0" :max="10000000" placeholder="货柜号" :controls="false"
        clearable></el-input-number>

      <el-select v-model="query.is_validate" clearable placeholder="是否有效" class="handle-select mr10">
        <el-option key="1" label="有效" value="1"></el-option>
        <el-option key="2" label="无效" value="0"></el-option>
      </el-select>

      <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
      <el-button type="primary" @click="uploadData">一键下载</el-button>
      <el-tooltip class="item" effect="dark"
        content="点击将会下载您所选中的柜门二维码，不可跨页进行选择，默认一页可全选10个，若需一页打印更多请在分页器处修改一页显示数据的尺寸再进行选择。" placement="top-start">
        <el-button class="el-button-problem" icon="el-icon-warning-outline" type="text"></el-button>
      </el-tooltip>
    </div>
    <el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header"
      @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55">
      </el-table-column>
      <el-table-column prop="id" label="ID" align="center" width="100"></el-table-column>
      <el-table-column label="商品名称">
        <template #default="scope">
          <el-button :style="'color:#409EFF'" type="text" @click="showDetail(scope.row.id)">
            {{ scope.row.product_name }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="所属门店" align="center" width="180">
        <template #default="scope">
          {{ scope.row.store_name }}
        </template>
      </el-table-column>
      <el-table-column label="封面" align="center" header-align="center" width="150">
        <template #default="scope">
          <el-image class="table-td-thumb" :src="scope.row.cover" :preview-src-list="[scope.row.cover]"
            :hide-on-click-modal="true"></el-image>
        </template>
      </el-table-column>

      <el-table-column label="价格" align="right" width="100">
        <template #default="scope" align="right">
          {{ scope.row.price / 100 }}
        </template>
      </el-table-column>
      <el-table-column label="箱子编号" align="center" width="100">
        <template #default="scope">
          {{ scope.row.moto_num }}
        </template>
      </el-table-column>
      <el-table-column label="显示编号" align="center" width="100">
        <template #default="scope">
          {{ scope.row.box_num }}
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center" width="150">
        <template #default="scope">
          <el-button type="text" :style="'color:' + [!scope.row.is_open ? 'red' : '']"
            @click="setIsOpen(scope.$index, scope.row.id, !scope.row.is_open)">
            {{ scope.row.is_open ? "打开" : "关闭" }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="太阳码" align="center" header-align="center" width="150">
        <template #default="scope">
          <el-image class="table-td-thumb" :src="scope.row.qrcode_url" :preview-src-list="[scope.row.qrcode_url]"
            :hide-on-click-modal="true"></el-image>
        </template>
      </el-table-column>
      <el-table-column label="是否有效" align="center" width="150">
        <template #default="scope">
          <el-button type="text" :style="'color:' + [!scope.row.is_validate ? 'red' : '']"
            @click="setIsValidate(scope.$index, scope.row.id, !scope.row.is_validate)">
            {{ scope.row.is_validate ? "有效" : "无效" }}
          </el-button>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" width="250">
        <template #default="scope">
          <el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row.id)">编辑
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination background layout="total,sizes, prev, pager, next" :page-sizes="[10, 20, 30, 40, 50, 100, 200]"
        :current-page="query.page" :page-size="query.page_size" :total="pageTotal" @size-change="handleSizeChange"
        @current-change="handlePageChange"></el-pagination>
    </div>
    <!-- 编辑弹出框 -->
    <el-dialog :title="actTitle" v-model="editVisible" width="40%">
      <el-form ref="form" :model="form" class="el-dialog__body model-h">

        <el-form-item label="商品名称" required>
          <el-input v-model="form.product_name" style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item label="价格" class="pl37">
          <el-input-number v-model="form.price" :precision="2" :min="0" :controls="false" :max="4294967295"
            style="width: 200px" />
        </el-form-item>
        <el-form-item label="显示编号" class="pl9">
          <el-input v-model="form.box_num" style="width: 200px" />
        </el-form-item>
        <el-form-item label="封面" class="pl37">
          <!--          <el-alert title="建议尺寸750（长）*560（宽）" type="success"/>-->
          <el-upload class="avatar-uploader img_style" :action="action" :show-file-list="false"
            :before-upload="beforeAvatarUpload" :http-request="uploadFile">
            <img v-if="form.cover" :src="form.cover" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <el-button type="text" @click="form.cover = ''" class="pl37" style="color: red">删除</el-button>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="editVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveEdit">确 定</el-button>
        </span>
      </template>
    </el-dialog>

    <!--详情弹出框-->
    <el-dialog title="商品详情" v-model="detailVisible" width="55%">
      <div class="detail_style">
        <div><img :src="detailData.cover" alt="商品封面"></div>
        <div class="row_style">
          <el-row :gutter="16">
            <el-col :span="6">
              <div class="grid-content bg-purple fw900">设备编号:</div>
            </el-col>
            <el-col :span="10">
              <div class="grid-content bg-purple">{{ detailData.pia_device_id }}</div>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="6">
              <div class="grid-content bg-purple fw900">箱子编号:</div>
            </el-col>
            <el-col :span="10">
              <div class="grid-content bg-purple">{{ detailData.moto_num }}</div>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="6">
              <div class="grid-content bg-purple fw900">商品名称:</div>
            </el-col>
            <el-col :span="10">
              <div class="grid-content bg-purple">{{ detailData.product_name }}</div>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="6">
              <div class="grid-content bg-purple fw900">价格:</div>
            </el-col>
            <el-col :span="10">
              <div class="grid-content bg-purple">{{ detailData.price / 100 + ' 元 ' }}</div>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="6">
              <div class="grid-content bg-purple fw900">状态:</div>
            </el-col>
            <el-col :span="10">
              <div class="grid-content bg-purple">{{ detailData.is_open ? "打开" : "关闭" }}</div>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="6">
              <div class="grid-content bg-purple fw900">是否有效：</div>
            </el-col>
            <el-col :span="10">
              <div class="grid-content bg-purple">{{ detailData.is_validate ? "有效" : "无效" }}</div>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="6">
              <div class="grid-content bg-purple fw900">创建时间：</div>
            </el-col>
            <el-col :span="18">
              <div class="grid-content bg-purple">{{ ForMatHMS(detailData.c_at) }}</div>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-dialog>


  </div>

</template>

<script>

import { getProduct, getProductList, saveProduct, setProductIsValidate, setProductIsOpen } from "@/api/pia"
import moment from "moment";

import { dataURLtoFile, imgCompress } from '@/utils/compress.js'
import { upload } from "@/api/editor.js"

import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';
import { getAreaOption, getStoreOption } from "@/api/store";
import JSZip from 'jszip'
import { saveAs } from 'file-saver'

export default {
  name: "PiaProductTable",
  data() {
    return {
      action: '#',
      storeOptions: [],
      query: {
        product_name: "",
        is_validate: null,
        mac_id: "",
        page: 1,
        page_size: 10,
        moto_num: undefined
      },
      actTitle: "编辑商品",
      form: {
        id: 0,
        product_name: "", // 商品名称
        cover: "", // 主图
        price: 0, // 价格
        box_num: null
      }, //提交表单数据
      tableData: [],
      pageTotal: 0,
      editVisible: false,
      file: {},
      //裁剪参数
      dialogVisible: false, // 上传图片裁切预览的弹出层是否显示
      previewImage: '', // 预览图片
      cropper: null, // 裁切器实例
      fileName: '', // 文件名称
      updatePhotoLoading: false, // 是否正在更新用户头像 loading显示与否
      piaDeviceId: 0,// 父组件参数
      detailVisible: false,
      detailData: {},
      areaOptions: [],
      area_store: [],
      props: {
        // checkStrictly: true,
        lazy: true,
        lazyLoad: this.lazyLoad
      },
      multipleSelection: []
    }
  },
  created() {
    this.init()
  },

  computed: {

  },
  methods: {
    init() {
      this.getData()
    },
    ForMatHMS(date) {
      return moment(parseInt(date + "000")).format("YYYY-MM-DD HH:mm:ss")
    },
    dateFormat: function (row, column) {
      const date = row[column.property];
      if (date === undefined) {
        return "";
      }
      return moment(parseInt(date + "000")).format("YYYY-MM-DD")
    },
    // 多选方法
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    tinymcechange(content) {
      this.form.content = content
      // this.$emit("tinymcechange", e);
    },
    // 触发搜索按钮
    handleSearch() {
      this.query.page = 1
      this.getData()
    },
    // 搜索商品
    getData() {
      this.query.area_id = this.area_store !== null ? this.area_store[0] : null
      this.query.store_id = (this.area_store !== null && this.area_store.length > 1) ? this.area_store[1] : null
      getProductList(this.query).then(res => {
        this.tableData = res.data
        if (this.query.page === 1) {
          this.pageTotal = res.count
        }
      })
    },
    oneTouch() {
      alert('该功能暂未开发')
    },
    lazyLoad(node, resolve) {
      const { level } = node;
      if (level === 0) {
        this.getAreaOptions()
        let nodes = []
        if (this.areaOptions !== []) {
          setTimeout(() => {
            nodes = this.areaOptions.map(item => ({
              value: item.value,
              label: item.label,
              leaf: level >= 1
            }));
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes);
          }, 500);
        }
      }
      if (level === 1) {
        let nodes = []
        this.getStoreOption(node.value)
        if (this.storeOptions !== []) {
          setTimeout(() => {
            nodes = this.storeOptions.map(item => ({
              value: item.value,
              label: item.label,
              leaf: level >= 1
            }));
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes);
          }, 500);
        }
      }

    },
    // 获取地址列表
    getAreaOptions() {
      getAreaOption().then(res => {
        this.areaOptions = res
      })
    },
    save(row) {
      saveProduct(row.id, row).then(res => {
        if (res) {
          this.$message.success('保存成功')
        }
        this.getData()
      })
    },

    // 分页导航
    handlePageChange(val) {
      this.query.page = val
      this.getData()
    },
    handleSizeChange(val) {
      this.query.page_size = val
      this.getData()
    },
    handleEdit(index, id) {
      this.idx = index;
      getProduct(id).then(res => {
        this.form.id = res.id
        this.form.box_num = res.box_num
        this.form.product_name = res.product_name
        this.form.cover = res.cover
        this.form.price = (res.price / 100).toFixed(2)
      }).then(
        this.editVisible = true
      )

    },

    // 添加操作
    handleAdd() {
      this.form = {}
      this.form.id = 0
      this.editVisible = true
    },

    saveEdit() {
      let paramData = Object.assign({}, this.form)
      paramData.price = paramData.price * 100
      saveProduct(this.form.id, paramData).then(res => {
        if (res === true) {
          this.$message.success("保存成功")
          this.getData()
          this.editVisible = false
        }
      })
    },

    setIsValidate(index, id, isValidate) {
      setProductIsValidate(id, isValidate).then(res => {
        if (res === true) {
          this.$message.success('保存成功')
          this.tableData[index].is_validate = isValidate
        }
      })
    },

    setIsOpen(index, id, isOpen) {
      setProductIsOpen(id, isOpen).then(res => {
        if (res === true) {
          this.$message.success('保存成功')
          this.tableData[index].is_open = isOpen
        }
      })
    },

    async beforeAvatarUpload(file) {
      file = await imgCompress(file)
      this.file = file
      file = file.file
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },

    uploadFile() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let formData = new FormData();
      formData.append("file", this.file.file);
      upload(formData).then(res => {
        if (res.url === undefined) {
          this.file = {}
        }
        this.form.cover = res.url
        this.file = {}
        loading.close();
      })
    },

    // 对话框完全打开后
    onDialogOpened() {
      const image = this.$refs['preview-image']
      const cropper = new Cropper(image, {
        aspectRatio: 1 / 1,
        viewMode: 1,
        dragMode: 'none',
        background: true,
        cropBoxResizable: true,
      })
      this.cropper = cropper
    },
    onDialogClosed() {
      // this.cropper = null
      this.previewImage = ''
      this.fileName = ''
      this.cropper.destroy()
    },
    onUpdatePhoto() {
      let img = this.cropper.getCroppedCanvas().toDataURL('image/jpeg')
      // eslint-disable-next-line no-unused-vars
      let newImg = dataURLtoFile(img, this.fileName)
    },

    // 父组件调用
    showProducts(id) {
      this.piaDeviceId = id
      this.query.pia_device_id = id
      this.getData();
    },

    //获取门店信息
    getStoreOption(id) {
      getStoreOption(id).then(res => {
        this.storeOptions = []
        res.forEach(function (val) {
          this.storeOptions.push({ label: val.label, value: parseInt(val.value) })
        }, this)
      })
    },

    //   展示详情
    showDetail(id) {
      this.tableData.forEach(item => {
        if (item.id === id) {
          this.detailData = JSON.parse(JSON.stringify(item))
        }
      })
      this.detailVisible = true
    },

    // 图片压缩前转换
    imgToBuffer(url) {
      return new Promise((resolve, reject) => {
        const xml = new XMLHttpRequest();
        xml.open('GET', url, true);
        xml.responseType = 'blob';
        xml.onload = function ({ currentTarget }) { //从事件对象结构出currentTarget
          const { status, response } = currentTarget;
          status === 200 ? resolve(response) : reject(status); // response就是转化后的
        };
        xml.send();
      });
    },
    // 开始压缩
    uploadData() {
      if (this.multipleSelection.length === 0) {
        this.$message.error('请先选择要下载二维码的柜门');
        return
      } else {
        const zip = new JSZip();
        const imgCache = {};
        const imgArr = [];
        let list = []
        this.multipleSelection.forEach(item => {
          list.push({
            name: item.store_name + '-ID' + item.id + '-柜门' + (item.box_num || item.moto_num),
            url: item.qrcode_url
          })
        })
        list.forEach((item) => { // urlList格式：[{url:图片链接,name:图片名称}...]
          // 逐个添加文件
          const promise = this.imgToBuffer(item.url).then((res) => {
            zip.file(`${item.name}.${res.type.split('/').pop()}`, res, { binary: true });
            imgCache[item.name] = res; // 下载文件, 并存成ArrayBuffer对象(blob)
          });
          imgArr.push(promise);
        });
        Promise.all(imgArr).then(() => {
          zip.generateAsync({ type: 'blob' }).then((content) => {
            saveAs(content, '智能货柜二维码'); // 打包压缩
            this.$message.success('压缩完成');
          }).catch((err) => {
            this.$message.error(err.message);
          });
        });
      }
    }
  }



};
</script>

<style scoped>
.handle-box {
  margin-bottom: 20px;
}

.handle-select {
  width: 120px;
}

.handle-input {
  width: 200px;
  display: inline-block;
}

.table {
  width: 100%;
  font-size: 14px;
}

.red {
  color: #ff0000;
}

.mr10 {
  margin-right: 10px;
}

.table-td-thumb {
  display: block;
  margin: auto;
  width: 40px;
  height: 40px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

/deep/.el-dialog__body {
  overflow: auto;
  margin: 0px;
  padding-bottom: 0;
}

.model-h {
  height: 20%;
}

.el-input,
.el-select,
.el-input-number {
  margin-right: 10px;
}

.pl37 {
  padding-left: 37px;
}

.img_style {
  padding-left: 37px;
  margin-top: 10px;
}

.detail_style {
  padding-left: 5%;
  display: flex;
}

.detail_style img {
  width: 300px;
  margin-right: 20px;
  flex: 1;
}

.row_style {
  flex: 1;
}

.el-row {
  margin-bottom: 20px;
}

.el-col {
  border-radius: 4px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

.fw900 {
  font-weight: 900;
}

.pl9 {
  padding-left: 9px;
}

/deep/.el-cascader {
  margin-right: 10px;
}

.el-button-problem {
  font-size: 20px;
  margin-left: 10px;
  //margin-top: 15px;
}
</style>
